import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_BY_COUNTRY = gql`
  query LenderRetailActivityByCountry($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      byCountry(input: $input) {
        success
        error
        entity {
          country
          creditApps
          approvedApps
          declinedApps
          pendingApps
        }
      }
    }
  }
`;
